import {defineMessages} from 'react-intl';

export default defineMessages({
  someoneWasUnavailable: {
    id: 'ciscospark.callDataActivity.message.someoneWasUnavailable',
    defaultMessage: '{name} was unavailable.'
  },
  youCancelledACall: {
    id: 'ciscospark.callDataActivity.message.youCancelledACall',
    defaultMessage: 'You cancelled a call.'
  },
  someoneCancelledACall: {
    id: 'ciscospark.callDataActivity.message.someoneCancelledACall',
    defaultMessage: '{name} cancelled a call.'
  },
  youHadACall: {
    id: 'ciscospark.callDataActivity.message.youHadACall',
    defaultMessage: 'You had a call ({duration})'
  },
  youMissedACall: {
    id: 'ciscospark.callDataActivity.message.youMissedACall',
    defaultMessage: 'You missed a call.'
  },
  youHadAMeeting: {
    id: 'ciscospark.callDataActivity.message.youHadAMeeting',
    defaultMessage: 'You had a meeting ({duration})'
  },
  nobodyJoinedYourMeeting: {
    id: 'ciscospark.callDataActivity.message.nobodyJoinedYourMeeting',
    defaultMessage: 'You started a meeting but no one was available.'
  },
  nobodyJoinedTheMeeting: {
    id: 'ciscospark.callDataActivity.message.nobodyJoinedTheMeeting',
    defaultMessage: '{name} cancelled a meeting.'
  },
  youMissedAMeeting: {
    id: 'ciscospark.callDataActivity.message.youMissedAMeeting',
    defaultMessage: 'You missed a meeting ({duration})'
  }
});
